import { userService } from "../_services";
const initialState = {
  all: {}
};
const state = Object.assign({}, initialState);
export const users = {
  namespaced: true,
  state: state,
  actions: {
    getAll({ commit }) {
      commit("getAllRequest");

      userService
        .getAll()
        .then(
          users => commit("getAllSuccess", users),
          error => commit("alert/error", error, { root: true })
        );
    }
  },
  mutations: {
    getAllRequest(state) {
      state.all = { loading: true };
    },
    getAllSuccess(state, users) {
      state.all = { items: users };
    },
    resetState(state) {
      for (let prop in state) {
        state[prop] = initialState[prop];
      }
    }
  }
};
